import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackbarMessageComponent } from './snackbar-message.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    SnackbarMessageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class SnackbarMessageModule { }
